export default angular.module('uibExtensions', ['ui.bootstrap']);
